<template>
    <div>
        <el-form :inline="true" :model="searchForm" class="forTbFilter" @submit.native.prevent>
            <el-form-item label="状态：">
                <el-select v-model="searchForm.state" clearable>
                    <el-option v-for="item in pkgStateOption" :value="item.code" :key="item.description"
                        :label="item.description"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="退款渠道：">
                <el-select v-model="searchForm.applyType" clearable>
                    <el-option v-for="item in pkgStateOptions" :value="item.code" :key="item.description"
                        :label="item.description"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="ICCID：">
                <el-input v-model.trim="searchForm.iccid" clearable></el-input>
            </el-form-item>
             <el-form-item label="支付宝账号：">
                <el-input v-model.trim="searchForm.phone" clearable></el-input>
            </el-form-item>
            <el-form-item label="订单号：">
                <el-input v-model.trim="searchForm.orderNo" clearable></el-input>
            </el-form-item>
            <el-form-item label="申请时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期"
                    end-placeholder="结束日期"></el-date-picker>
            </el-form-item>
            <br>
            <el-form-item class="btnArea">
                <el-button type="primary" @click="getPkgListPageHandle">搜索查询</el-button>
                <el-button type="primary" @click="showAddPkg">新增退款</el-button>
                <el-button type="success" @click="confirmExportDialogVisible = true">导出退款</el-button>
                <el-button type="success" @click="confirmExportDialogVisible1 = true">导出订单</el-button>
                <el-button type="primary" @click="showImportApply">EXCEL处理投诉</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData" border>
            <el-table-column prop="id" label="序号"></el-table-column>
            <el-table-column prop="iccid" label="ICCID" width="180px"></el-table-column>
            <el-table-column prop="orderNo" label="订单号" width="180px"></el-table-column>
            <el-table-column prop="name" label="姓名"></el-table-column>
            <el-table-column prop="phone" label="支付宝账号"></el-table-column>
            <el-table-column prop="price" label="退款金额"></el-table-column>
            <el-table-column align="center" label="申请备注" width="100px">
                <template v-slot="scope">

                    <el-tooltip :content="scope.row.applyRemark">
                        <p> {{ scope.row.applyRemark }}</p>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="kefuName" label="申请人"></el-table-column>
            <el-table-column prop="createTime" label="申请时间" width="140px"></el-table-column>
            <el-table-column prop="stateName" label="处理状态"></el-table-column>
            <el-table-column align="center" label="处理备注" width="100px">
                <template v-slot="scope">

                    <el-tooltip :content="scope.row.disRemark">
                        <p> {{ scope.row.disRemark }}</p>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="disTime" label="处理时间" width="140px"></el-table-column>
            <el-table-column label="操作">
                <template v-slot="scope">
                    <el-button type="text" size="small" @click="showEditPkg(scope.row)">处理退款</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage" :page-sizes="[15, 50, 100, 500]" :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="tbpg.total">
        </el-pagination>
        <el-dialog :append-to-body="true" :title="title" :visible.sync="addPkgVisibale" width="600px" @close="cancel"
            :close-on-click-modal="false">
            <el-form ref="addOrEditPkgForm" :model="addOrEditPkgForm" label-width="120px">
                <el-form-item label="订单号:" prop="orderNo">
                    <el-col :span="22">
                        <el-input v-model.trim="addOrEditPkgForm.orderNo" placeholder="必填" clearable></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="ICCID:" prop="iccid">
                    <el-col :span="22">
                        <el-input v-model.trim="addOrEditPkgForm.iccid" placeholder="必填" clearable></el-input>
                    </el-col>
                </el-form-item>

                <el-form-item label="真实姓名:" prop="name">
                    <el-col :span="22">
                        <el-input v-model.trim="addOrEditPkgForm.name" placeholder="必填" clearable></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="支付宝账号:" prop="phone">
                    <el-col :span="22">
                        <el-input v-model.trim="addOrEditPkgForm.phone" placeholder="必填" clearable></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="退款金额:" prop="price">
                    <el-col :span="22">
                        <el-input v-model.trim="addOrEditPkgForm.price" placeholder="退款金额/元" clearable></el-input>
                    </el-col>
                </el-form-item>

                <el-form-item label="申请备注:" prop="applyRemark">
                    <el-col :span="22">
                        <el-input v-model.trim="addOrEditPkgForm.applyRemark" placeholder="必填" clearable></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="退款渠道：" prop="applyType">
                    <el-radio-group v-model="addOrEditPkgForm.applyType">
                        <el-radio :label="0">支付宝</el-radio>
                        <el-radio :label="1">微信</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="付款截图：">
                    <input type="file" ref="file1">
                    <div v-if="!existBackImg">选填：</div>
                    <img v-else :src="getImgUrl() + addOrEditPkgForm.applyImg" alt="" width="150" height="150">
                </el-form-item>
                <el-form-item label="收款二维码：">
                    <input type="file" ref="file2">
                    <div v-if="!existBackImg">选填：</div>
                    <img v-else :src="getImgUrl() + addOrEditPkgForm.aliImg" alt="" width="150" height="150">
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="addOrEidtPkgHandle">确 定</el-button>
            </div>

        </el-dialog>




        <el-dialog :append-to-body="true" title="处理退款" :visible.sync="addPkgVisibaleDis" width="600px" @close="cancel"
            :close-on-click-modal="false">
            <el-form ref="addOrEditPkgForm" :model="addOrEditPkgForm" label-width="120px">
                <el-form-item label="订单号:" prop="orderNo">
                    <el-col :span="22">
                        <el-input v-model.trim="addOrEditPkgForm.orderNo" disabled clearable></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="真实姓名:" prop="name">
                    <el-col :span="22">
                        <el-input v-model.trim="addOrEditPkgForm.name" disabled clearable></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="支付宝账号:" prop="phone">
                    <el-col :span="22">
                        <el-input v-model.trim="addOrEditPkgForm.phone" disabled clearable></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="退款金额/元:" prop="price">
                    <el-col :span="22">
                        <el-input v-model.trim="addOrEditPkgForm.price" disabled clearable></el-input>
                    </el-col>
                </el-form-item>

                <el-form-item label="付款截图：">
                    <img :src="addOrEditPkgForm.applyImg" alt="" width="150" height="150">
                </el-form-item>


                <el-form-item label="收款二维码：">
                    <el-image class="img-defined" :src="addOrEditPkgForm.aliImg" 
                    :preview-src-list="[addOrEditPkgForm.aliImg]" alt=""></el-image >
                </el-form-item>

         


             
                <el-form-item label="处理结果：" prop="state">
                    <el-radio-group v-model="addOrEditPkgForm.state">
                        <el-radio :label="0">待处理</el-radio>
                        <el-radio :label="1">已退款</el-radio>
                        <el-radio :label="2">已拒绝</el-radio>
                    </el-radio-group>
                </el-form-item>


                <el-form-item label="处理备注:" prop="disRemark">
                    <el-col :span="22">
                        <el-input v-model.trim="addOrEditPkgForm.disRemark" placeholder="必填" clearable></el-input>
                    </el-col>
                </el-form-item>


            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="applyBack">确 定</el-button>
            </div>

        </el-dialog>

        <el-dialog :append-to-body="true" title="提示" :visible.sync="confirmExportDialogVisible1" width="30%">
            <span>确定要导出吗</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmExportDialogVisible1 = false">取 消</el-button>
                <el-button type="primary" @click="exportApplyHandler1">确 定</el-button>
            </span>
        </el-dialog>


        <el-dialog :append-to-body="true" title="提示" :visible.sync="confirmExportDialogVisible" width="30%">
            <span>确定要导出吗</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmExportDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="exportApplyHandler">确 定</el-button>
            </span>
        </el-dialog>


        <el-dialog :append-to-body="true" title="处理退款" :visible.sync="importVisible" width="600px"
            :close-on-click-modal="false">
            <el-form :model="dealWithForm" label-width="120px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('kefu/apply/batch/update')" :headers="setHeader()" :limit="1"
                        :auto-upload="false" :on-success="handleSuccess">
                        <el-button slot="trigger" plain>导入Excel</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="importApplyHandler">确 定</el-button>
            </div>
        </el-dialog>


    </div>
</template>
<script>
import { getPkgListPage, addPkg, updatePkg, getPkgDetail, changePkgState, adminPkgSort } from '@/api/package.js'
import common from '@/utils/common.js'
export default {
    data() {
        return {
            confirmExportDialogVisible: false,
            confirmExportDialogVisible1: false,

            addPkgVisibaleDis: false,
            shareImgs: false,
            frontImgUrl: '',
            existBackImg: false,
            searchForm: {
                shopTuiImg: '',
                type: '',
                time: '',
                supplierType: '',
                shopState: null,
                pkgName: '',
                state: ''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0,
            },
            pkgTypeOption: [],
            pkgStateOption: [
                { 'code': 0, 'description': '待审核' },
                { 'code': 1, 'description': '已退款' },
                { 'code': 2, 'description': '已拒绝' }
            ],

            pkgStateOptions: [
                { 'code': 0, 'description': '支付宝' },
                { 'code': 1, 'description': '微信' },
            ],
            pkgStatesOption: [
                { 'code': 0, 'description': '禁用' },
                { 'code': 1, 'description': '启用' }
            ],
            agentStateOption: [
                { 'code': 1, 'description': '允许' },
                { 'code': 2, 'description': '不允许' }
            ],
            supplierOption: [],
            supplierOptions: [],
            addOrEditPkgForm: {
                id: '',
                applyType:'',
                orderNo: '',
                name: '',
                phone: '',
                applyRemark: '',
                price: '',
                createTime: '',
                disTime: '',
                applyImg: '',
                aliImg: '',
                iccid: '',
                kefuName: '',
                disRemark: '',
                state: '',


            },
            unit: 'G',
            currentId: '',
            addFlag: null,
            addPkgVisibale: false,
            pkgGroup: [],
            myPkgGroup: [],
            title: '',
            message: '',
            urls: '',
            importVisible: false
        }
    },
    methods: {
        importApplyHandler() {
            this.$refs.upload.submit();
        },
        handleSuccess(res) {
            if (res.code == 200) {
                this.importVisible = false;
                this.getPkgListPageHandle();
                this.$refs.upload.clearFiles();
                this.$message.success(res.message);
            } else {
                this.$message.error(res.message);
            }
        },
        
        showImportApply() {
            this.importVisible = true;
        },

        exportApplyHandler() {
            this.searchForm.addressNo1 = '1';
            var data = JSON.parse(JSON.stringify(this.searchForm));
            if (data.time) {
                data.startTimeString = data.time[0] + " 00:00:00";
                data.endTimeString = data.time[1] + " 23:59:59";
            } else {
                data.startTimeString = "";
                data.endTimeString = "";
            }
            delete data.time;

            this.exportExcel("/mould/download/kefu/apply", data);
            this.confirmExportDialogVisible = false;
        },
        exportApplyHandler1() {
            this.searchForm.addressNo1 = '1';
            var data = JSON.parse(JSON.stringify(this.searchForm));
            if (data.time) {
                data.startTimeString = data.time[0] + " 00:00:00";
                data.endTimeString = data.time[1] + " 23:59:59";
            } else {
                data.startTimeString = "";
                data.endTimeString = "";
            }
            delete data.time;

            this.exportExcel("/mould/download/kefu/all", data);
            this.confirmExportDialogVisible1 = false;
        },

        applyBack() {
            common.sysRequest('kefu/apply/update', this.addOrEditPkgForm, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                    this.addPkgVisibaleDis = false;
                    this.getPkgListPageHandle();
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        cancel() {
            this.importVisible = false;
            this.addPkgVisibaleDis = false;
            this.shareImgs = false;
            this.addPkgVisibale = false;
            this.$refs.addOrEditPkgForm.resetFields();
        },
        showbtnText(state) {
            return common.showTxtByState(state, { 0: '上架', 1: '下架' })
        },
        //同步上游套餐
        updateUpPkg() {
            common.sysRequest('pkg/update/up/pkg', null, 'get').then(res => {
                if (res.data.code == 200) {
                    this.getPkgListPageHandle();
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        numberHandle(e) {
            var reg = /^\d+(\.\d{1,2})?/;
            if (reg.exec(e.target.value)) {
                e.target.value = reg.exec(e.target.value)[0];
            }
        },
        getPkgListPageHandle($event) {
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            common.sysRequest('kefu/apply/list', data, 'post').then(res => {
                if (res.data.code == 200) {
                    common.listCallback(this, res, 'tbpg');
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        showAddPkg() {
            for (let val in this.addOrEditPkgForm) {
                this.addOrEditPkgForm[val] = "";
            }
            this.addPkgVisibale = true;
            this.addFlag = true;
            this.title = '新增退款';
        },
        showEditPkg1(row) {
            var data = {
                id: row.id
            }
            common.sysRequest('app/pc/share/urls', data, 'post').then(res => {
                if (res.data.code == 200) {
                    this.addOrEditPkgForm.shareImg = res.data.data.img; 
                    this.shareImgs = true;
                    this.urls = res.data.data.url;
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        showEditPkg(row) {
            for (var key in this.addOrEditPkgForm) {
                this.addOrEditPkgForm[key] = row[key]
            }
            this.addPkgVisibaleDis = true;

        },
        addOrEidtPkgHandle() {
            this.$refs.addOrEditPkgForm.validate(valid => {
                if (valid) {
                    let fd = new FormData();
                    Object.keys(this.addOrEditPkgForm).forEach((key) => {
                        fd.append(key, this.addOrEditPkgForm[key]);
                    })
                    fd.append('applyImgs', this.$refs.file1.files[0]);
                    fd.append('aliImgs', this.$refs.file2.files[0]);
                    common.sysRequest("/kefu/apply/insert", fd, 'post').then(res => {
                        if (res.data.code == 200) {
                            this.$message.success(res.data.message);
                            callback(res);
                            for (let val in this.addOrEditPkgForm) {
                                this.addOrEditPkgForm[val] = "";
                            }
                        } else {
                            this.$message.error(res.data.message);
                        }
                    }).catch(err => console.error(err));
                }
                var _this = this;
                function callback(res) {
                    if (res.data.code == 200) {
                        _this.getPkgListPageHandle();
                        _this.addPkgVisibale = false;
                        _this.existBackImg = false;
                        this.$refs.file1.value = "";
                        this.$refs.file2.value = "";
                    } else {
                        _this.$message.error(res.data.message)
                    }
                }
            })
        },
        changePkgStateHandle(id) {
            var data = {
                id
            }
            changePkgState(data).then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                    this.getPkgListPageHandle();
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        updateSortNo(row) {
            //修改排序号
            var data = {
                id: row.id,
                sort: row.sort
            }
            common.sysRequest('app/pc/update/store/sort', data, 'post').then(res => {
                if (res.data.code == 200) {
                    this.getPkgListPageHandle();
                }
            })

        },
        handleSizeChange(val) {
            this.tbpg.pageSize = val;
            this.getPkgListPageHandle();
        },
        handleCurrentChange(val) {
            this.tbpg.currentPage = val;
            this.getPkgListPageHandle();
        },
        //选择套餐组
        whenChoosePagGroup(val) {
            for (let index in this.pkgGroup) {
                if (this.pkgGroup[index].id == val) {
                    this.addOrEditPkgForm.supplierType = this.pkgGroup[index].supplierType;
                }
            }
            if (this.addOrEditPkgForm.supplierType == 66) {
                common.sysRequest('external/pkg/list', null, 'get').then(res => {
                    if (res.data.code == 200) {
                        this.myPkgGroup = res.data.data.map.pkgs;
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
            }

        }

    },
    created() {
        common.getSupplierOptionCom(this, 'supplierOptions');
        this.getPkgListPageHandle();
        common.sysRequest('app/pc/share/info/list', {}, 'post').then(res => {
            if (res.data.code == 200) {
                this.supplierOption = res.data.data;
            } else {
                this.$message.error(res.data.message);
            }
        })
    }
}
</script>
<style lang="less" >
.input-with-select .el-input {
    width: 60px;
}
.verifiedDialog {
    .img-defined {
        width: 100px;
        height: 80px;
        margin-left: 10px;
        &:first-child {
            margin-left: 0;
        }
        
    }

}
</style>

